/* Signature — "Will It Fit?" calculator.

   Pure arithmetic on numbers the shopper enters. It reports geometric
   clearance only; it never claims a delivery outcome, and it says so. */
(function () {
  'use strict';

  /* Bind every fit form on the page — the homepage tool and the per-product
     embed share the same arithmetic and the same honest framing. */
  document.querySelectorAll('[data-fit-tool]').forEach(bindFitForm);

  function bindFitForm(form) {
  const out = form.querySelector('[data-fit-result]');

  const num = (key) => {
    const el = form.querySelector('[data-fit="' + key + '"]');
    const v = el ? parseFloat(el.value) : NaN;
    return Number.isFinite(v) && v > 0 ? v : null;
  };

  function line(ok, text) {
    return { ok: ok, text: text };
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const pw = num('pw');
    const ph = num('ph');
    const pd = num('pd');
    const dw = num('dw');
    const dh = num('dh');
    const hw = num('hw');

    if (!pw || !ph || !pd) {
      out.className = 'fitguide__result is-shown';
      out.textContent = 'Enter the width, height and depth of the piece to check the fit.';
      return;
    }

    /* The two smallest dimensions decide what can pass through an opening,
       since the piece can be turned on its side or end. */
    const dims = [pw, ph, pd].sort((a, b) => a - b);
    const smallest = dims[0];
    const middle = dims[1];
    const longest = dims[2];

    const checks = [];

    if (dw && dh) {
      const opening = [dw, dh].sort((a, b) => a - b);
      const fits = smallest <= opening[0] && middle <= opening[1];
      const clearance = Math.min(opening[0] - smallest, opening[1] - middle);
      checks.push(
        line(
          fits,
          fits
            ? 'Doorway: fits with about ' + clearance.toFixed(1) + '" to spare when turned.'
            : 'Doorway: too tight. The two smallest sides (' + smallest + '" x ' + middle + '") must both clear the opening.'
        )
      );
    }

    if (hw) {
      /* Turning a corner needs roughly the longest side to clear the hallway. */
      const fits = hw >= smallest;
      const turns = hw >= longest;
      checks.push(
        line(
          fits,
          fits
            ? turns
              ? 'Hallway: wide enough to carry it through and turn a corner.'
              : 'Hallway: wide enough to pass straight through, but turning a corner will be tight — the longest side is ' + longest + '".'
            : 'Hallway: narrower than the smallest side of the piece.'
        )
      );
    }

    if (!checks.length) {
      out.className = 'fitguide__result is-shown';
      out.textContent = 'Add at least a doorway or hallway measurement to check the route.';
      return;
    }

    const allOk = checks.every((c) => c.ok);
    out.className = 'fitguide__result is-shown';
    out.textContent = '';

    const head = document.createElement('p');
    head.innerHTML = '<strong>' + (allOk ? 'Looks like it fits.' : 'Some measurements are tight.') + '</strong>';
    out.appendChild(head);

    const ul = document.createElement('ul');
    checks.forEach((c) => {
      const li = document.createElement('li');
      li.textContent = (c.ok ? '✓ ' : '✗ ') + c.text;
      ul.appendChild(li);
    });
    out.appendChild(ul);

    const note = document.createElement('p');
    note.className = 'text-small text-muted';
    note.textContent =
      'This is a geometry check on the numbers you entered. Measure twice, and allow for stair turns, railings, ceiling height and packaging, which are not included here.';
    out.appendChild(note);

    if (window.sigAnnounce) window.sigAnnounce(allOk ? 'Looks like it fits' : 'Some measurements are tight');
  });
  }
})();
